import { useMemo } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import { getAppName, isRecognizedAppName } from '../utils/app';
import { findACRouteForPath } from '../routes/academyRoutes';
const extractPathname = to => {
  if (typeof to === 'string') {
    return new URL(to, window.location.origin).pathname;
  }
  return to.pathname;
};
export const shouldReloadLocation = to => {
  const currentApp = getAppName();
  if (!isRecognizedAppName(currentApp)) {
    return false;
  }
  const pathname = extractPathname(to);
  if (!pathname) {
    return false;
  }
  const match = findACRouteForPath(pathname);
  if (!match) {
    return false;
  }
  return match.appName !== currentApp;
};
export const useShouldReloadLocation = to => {
  const history = useHistory();
  to = typeof to === 'function' ? to(history.location) : to;
  return useMemo(() => shouldReloadLocation(to), [to]);
};